export default "__VITE_ASSET__Zk$uXs78__"